import type { Routes } from '@angular/router';

import { RoutePath } from '@malou-io/package-utils';

import { CLIENTS_ROUTES } from '#modules/clients/routes/clients.routing';
import { GALLERY_ROUTES } from '#modules/gallery/routes/gallery.routing';
import { KEYWORDS_ROUTES } from '#modules/keywords/routes/keywords.routing';
import { MESSAGE_TEMPLATES_ROUTES } from '#modules/templates/routes/message-templates.routing';
import { REVIEW_TEMPLATES_ROUTES } from '#modules/templates/routes/review-templates.routing';

export const RESOURCES_ROUTES: Routes = [
    {
        path: '',
        loadComponent: () =>
            import('#shell/layouts/logged-in-layout/restaurants/resources-layout/resources-layout.component').then(
                (m) => m.ResourcesLayoutComponent
            ),
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'gallery',
            },
            {
                path: 'gallery',
                loadChildren: () => GALLERY_ROUTES,
                data: { routePath: RoutePath.GALLERY },
            },
            {
                path: 'review-templates',
                loadChildren: () => REVIEW_TEMPLATES_ROUTES,
                data: { routePath: RoutePath.REVIEW_TEMPLATES },
            },
            {
                path: 'message-templates',
                loadChildren: () => MESSAGE_TEMPLATES_ROUTES,
                data: { routePath: RoutePath.MESSAGE_TEMPLATES },
            },
            {
                path: 'clients',
                loadChildren: () => CLIENTS_ROUTES,
                data: { routePath: RoutePath.CUSTOMERS },
            },
            {
                path: 'keywords',
                loadChildren: () => KEYWORDS_ROUTES,
                data: { routePath: RoutePath.KEYWORDS },
            },
            // redirectTo cannot go backwards higher than path resources/ so we use a component to navigate to updated path
            {
                path: 'totems',
                loadComponent: () => import('#core/components/url-redirect/url-redirect.component').then((m) => m.UrlRedirectComponent),
            },
            {
                path: 'boosters',
                loadComponent: () => import('#core/components/url-redirect/url-redirect.component').then((m) => m.UrlRedirectComponent),
            },
            {
                path: 'booster', // This one is because there was a typo in one of the redirect links from emails
                loadComponent: () => import('#core/components/url-redirect/url-redirect.component').then((m) => m.UrlRedirectComponent),
            },
        ],
    },
];
